<div class="container">
  <div class="heading_align">
    <div class="heading">Warunki użytkowania <span class="font_14 font_normal"> - dla Synappx™</span></div>
  </div>

  <div mat-dialog-content>
    @if (!showSCPToU) {
      <div mat-dialog-content>
        <div class="eula_points"><b>WAŻNE OD: 25/04/2023</b></div>
        <div class="eula_points">
          Poniższe Warunki Użytkowania Synappx™, wraz z podaną do wglądu polityką prywatności <a tabindex="-1"
          class="text_underline" [href]="privacyUrl" target="_blank"><b>Synappx Privacy Policy</b></a> (razem:
          „Umowa”) stanowią porozumienie zawarte przez Sharp Corporation („Sharp”) i Klienta. Umowa reguluje dostęp i
          korzystanie z Synappx oraz wszelkich Usług dostępnych poprzez Synappx. Do celów niniejszej Umowy termin
          „Synappx” oznacza Synappx Go, Synappx Admin Portal i związaną z nimi Dokumentację; termin „Usługi”
          oznacza Usługi Synappx, Określone Usługi dot. Oprogramowania i wszelką powiązaną Dokumentację, która może
          stanowić własność Sharp i/lub zewnętrznych dostawców usług („Zewnętrzni Dostawcy Usług”), dostępne poprzez
          Usługę Synappx Service.
        </div>
      </div>
    }
    @if (showSCPToU) {
      <div mat-dialog-content>
        <div class="eula_points"><b>WAŻNE OD: 11 lipiec 2023</b></div>
        <div class="eula_points">
          Poniższe Warunki Użytkowania Synappx™, wraz z podaną do wglądu polityką prywatności <a tabindex="-1"
          class="text_underline" [href]="privacyUrl" target="_blank"><b>Synappx Privacy Policy</b></a> (razem:
          „Umowa”) stanowią porozumienie zawarte przez Sharp Corporation („Sharp”) i Klienta. Umowa reguluje dostęp i
          korzystanie z Synappx oraz wszelkich Usług dostępnych poprzez Synappx. Do celów niniejszej Umowy termin
          „Synappx” oznacza Synappx Go, Synappx Cloud Print, Synappx Admin Portal i związaną z nimi Dokumentację; termin „Usługi”
          oznacza Usługi Synappx, Określone Usługi dot. Oprogramowania i wszelką powiązaną Dokumentację, która może
          stanowić własność Sharp i/lub zewnętrznych dostawców usług („Zewnętrzni Dostawcy Usług”), dostępne poprzez
          Usługę Synappx Service.
        </div>
      </div>
    }
    <div class="eula_points">
      Korzystanie z Usług jest przeznaczone dla firm/organizacji („Klient”) i ich Użytkownika
      Końcowego/Użytkowników Końcowych. Termin „Użytkownik Końcowy/Użytkownicy Końcowi” oraz jego formy oznacza
      każdą osobę uzyskującą dostęp do usług dostarczanych przez Usługę Synappx Service i może obejmować m.in.
      pracowników, przedstawicieli, wykonawców, pośredników Klienta i inne osoby korzystające lub uzyskujące
      dostęp do Usług w ramach Konta Klienta, upoważnione przez Klienta do korzystania z Usług. Wszelkie
      odniesienia do terminu „Klient” odnoszą się także do upoważnionego przez Klienta
      Administratora/Administratorów i wszelkich Użytkowników Końcowych, indywidualnie lub zbiorowo.
    </div>
    <div class="eula_points">
      Przed skorzystaniem i przed zezwoleniem Klientowi na dostęp, upoważniony Administrator/Administratorzy
      Klienta musi w imieniu Klienta zaakceptować warunki Umowy. Klikając „Zgadzam się”, Administrator oświadcza,
      że: 1) został wyznaczony przez Klienta na „Administratora” i posiada wszelkie prawa i przywileje związane ze
      stanowiskiem Administratora (szczegółowy opis poniżej); 2) jest upoważniony do prawnego zobowiązania Klienta
      na mocy niniejszej Umowy. W przypadku gdy Klient nie wyznaczył Cię na Administratora, lub gdy nie posiadasz
      opisanych powyżej uprawnień nie możesz kliknąć opcji „Zgadzam się”, zaś Klient nie może uzyskać dostępu ani
      korzystać z Usług. Po kliknięciu „Zgadzam się”, Klient ma prawo uzyskiwać dostęp i korzystać z Usług zgodnie
      z warunkami niniejszej Umowy.
    </div>
    <div class="eula_points">
      Inne określone usługi dot. oprogramowania („Określone Usługi dot. Oprogramowania”) mogą być dostępne w
      ramach lub poprzez Synappx Admin Services umożliwiając Klientowi realizację określonych funkcji bądź
      korzystanie z dodatkowych usług i funkcjonalności; te Określone Usługi dot. Oprogramowania są własnością
      firmy Sharp i/lub Zewnętrznych Dostawców Usług. Klient przyjmuje do wiadomości, że korzystanie i/lub
      uzyskiwanie dostępu do takich Określonych Usług dot. Oprogramowania może wymagać wyrażenia przez Klienta,
      Administratora/Administratorów i/lub Użytkowników Końcowych zgody na dodatkowe warunki mające zastosowanie w
      przypadku korzystania i/lub uzyskiwania dostępu do Określonych Usług dot. Oprogramowania („Warunki
      Dodatkowe”). W przypadku gdy Klient, Administrator/Administratorzy i/lub Użytkownicy Końcowy nie zaakceptują
      tych warunków, bądź nie posiadają uprawnień do akceptacji Warunków Dodatkowych, Klient,
      Administrator/Administratorzy i/lub Użytkownicy Końcowi nie mogą korzystać ani uzyskiwać dostępu do
      konkretnych Określonych Usług dot. Oprogramowania. W przypadku rozbieżności pomiędzy niniejszą Umową a
      Warunkami Dodatkowymi, wiążące będą Warunki Dodatkowe, jednak wyłącznie w odniesieniu do Określonej Usługi
      dot. Oprogramowania.
    </div>

    <div>
      <div class="eula_points">
        <b>A. Definicje</b> <br />
        Poza terminami zdefiniowanymi powyżej, w Umowie stosuje się następujące definicje:
        <ol>
          <li> <b>Konto Klienta:</b> Wszelkie konta dotyczące lub przypisane do
          Klienta, w tym wszelkie Konta Administratora, a także wszelkie Usługi, na które Klient,
          Administrator/Administratorzy i/lub Użytkownicy Końcowi posiadają licencje oraz wszelkie
          informacje i dane powiązane z Klientem, Administratorem/Administratorami i Użytkownikami
        Końcowymi.</li>
        <li> <b>Administrator:</b> Pracownik/pracownicy wyznaczeni przez Klienta do
        zarządzania informacjami i danymi związanymi z Kontem Klienta, oraz do uzyskiwania dostępu do
      Usług i licencji na Usługi w imieniu Klienta.</li>
      <li> <b>Konto Administratora:</b> Odnosi się to do konta administratora.
    </li>
    <li> <b>Dane Klienta:</b> Wszelkie dane i informacje przechowywane,
    przekazywane, przetwarzane, lub takie, do których Klient, Administrator/Administratorzy i/lub
  jego Użytkownicy Końcowi uzyskują dostęp poprzez Usługi, bądź powiązane z Kontem Klienta.</li>
  <li> <b>Sprzedawca:</b> Autoryzowany sprzedawca sprzedający Usługi
  Klientowi; Sprzedawcą może być firma Sharp, jej spółka zależna, lub jej bezpośrednie oddziały
  sprzedażowe (w przypadku sprzedaży bezpośredniej skierowanej do Klienta), lub autoryzowany
  sprzedawca zewnętrzny produktów i usług Sharp. Sprzedawca jest także głównym kanałem kontaktowym
  dla Klientów w przypadku potrzeby wsparcia związanego z Usługami. Sprzedawca może świadczyć
usługi na rzecz Klienta na podstawie umowy z Klientem i/lub Administratorem.</li>
<li> <b>Dokumentacja:</b> Wszelkie instrukcje instalacji i instrukcje
użytkownika, pliki pomocy, FAQ związane z dostępem i korzystaniem z Usług.</li>
<li> <b>Prawa własności intelektualnej:</b> Wszelkie prawa podlegające
patentom, prawu autorskiemu, tajemnicy handlowej, znakom towarowym, prawom osobistym i inne
prawa własności intelektualnej obowiązujące obecnie i w przyszłości na całym świecie.</li>
</ol>
</div>
<div class="eula_points">
  <b>B. Korzystanie przez Klienta i Obowiązki Klienta </b>
  <ol>
    <li> Klient odpowiada za wyznaczenie osoby/osób, które będą uprawnione do pełnienia i przyjmą
      funkcję Administratora w imieniu Klienta. Klient może przypisywać i zmieniać przypisanie Kont
    Administratora.</li>
    <li> Klient odpowiada za: zarządzanie dostępem do Kont Administratora i zapewnianie dostępu i/lub
      korzystanie z Usług przez Klienta, Administratora/Administratorów i Użytkowników Końcowych,
      zgodnie Umową, Warunkami Dodatkowymi i wszelką stosowną Dokumentacją. Firma Sharp ani Sprzedawca
      nie odpowiadają w imieniu Klienta za wewnętrzne zarządzanie, administrowanie, ani korzystanie z
    Usług.</li>
    <li> Klient przyjmuje do wiadomości, że jego Administrator/Administratorzy i Użytkownicy Końcowi
      podlegają i mają obowiązek postępować zgodnie z postanowieniami Umowy, Warunkami Dodatkowymi,
      Dokumentacją oraz wszelkimi stosownymi przepisami, w tym ustawowymi i wykonawczymi, związanymi z
      korzystaniem z Usług. Wyłączna odpowiedzialność za czyny i zaniechania Klienta, jego
      Administratora/Administratorów i Użytkowników Końcowych, a także odpowiedzialność za
      niewywiązanie się z warunków niniejszej Umowy, Warunków Dodatkowych, Dokumentacji oraz
      przepisów, w tym ustawowych i wykonawczych związanych z korzystaniem z Usług spoczywa na
      Kliencie. Odpowiedzialność ta obejmuje wszelkie działania w ramach Konta Klienta, niezależnie od
      tego, czy są to działania podejmowane przez Klienta, jego pracowników, czy stronę trzecią (w tym
    m.in. wykonawców, przedstawicieli i pośredników Klienta).</li>
    <li> Klient odpowiada za przestrzeganie przez Administratora/Administratorów i Użytkowników
      Końcowych wszelkich stosownych zobowiązań, warunków i polityk zatrudnienia klienta, ponieważ
    wiążą się one z uzyskiwaniem dostępu i korzystaniem z Usług.</li>
    <li> Klient zgadza się uzyskać od Użytkowników Końcowych, a także utrzymywać, wszelkie stosowne
      zgody w celu umożliwienia Administratorom działań opisanych w Umowie oraz umożliwienia firmie
    Sharp i/lub Zewnętrznym Dostawcom Usług świadczenie Usług.</li>
    <li> Klient odpowiada i ma obowiązek zapobiegać nieuprawnionemu dostępowi i/lub korzystaniu z Usług
      przez Klienta, Administratora/Administratorów i Użytkowników Końcowych i przez wszelkie strony
      trzecie. Klient niezwłocznie powiadomi firmę Sharp oraz Sprzedawcę o nieuprawnionym dostępie
      i/lub korzystaniu z Usług. Sharp ani Sprzedawca nie ponoszą odpowiedzialności za nieuprawniony
    dostęp i korzystanie z Kont Klienta.</li>
    <li> Klient będzie korzystał z Usług wyłącznie do celów własnej wewnętrznej działalności biznesowej,
      nie zaś w celu świadczenia usług innym podmiotom (service bureau) lub usług typu „timesharing”.
      Klient świadomie i dobrowolnie nie będzie korzystać z Usług, ani nie zezwoli na korzystanie z
      Usług w sposób, który mógłby skutkować uszkodzeniem, wyłączeniem, przeciążeniem, pogorszeniem
      lub innym zakłóceniem świadczenia Usług; powyższe obejmuje m.in. korzystanie z Usług w celu
      rozsyłania wirusów lub uszkodzonych plików, co mogłoby w jakikolwiek sposób pogorszyć
    integralność i bezpieczeństwo Usług.</li>
    <li> Klient nie może i dołoży starań, by również jego Administrator/Administratorzy i Użytkownicy
      Końcowi, pośrednio bądź bezpośrednio: (a) nie odtwarzali kodu źródłowego, nie przeprowadzali
      dekompilacji, dezasemblacji, ani nie podejmowali prób ustalenia kodu źródłowego, kodu obiektów
      ani podstawowej struktury, idei ani algorytmu Usług, oprogramowania, Dokumentacji i danych
      powiązanych lub dostarczonych z Usługami lub poprzez Usługi; (b) nie modyfikowali, nie
      dokonywali przekładów, ani nie tworzyli dzieł pochodnych w oparciu o Usługi; nie tworzyli kopii
      (za wyjątkiem kopii do celów archiwalnych), nie wypożyczali, nie dzierżawili, nie rozprowadzali,
      nie sprzedawali, ani nie odsprzedawali, nie zastawiali, nie przenosili, ani w inny sposób nie
      obciążali praw do Usług; (c) nie korzystali ani nie wykorzystywali dostępu do Usług w celu
      stworzenia lub wsparcia, i/lub nie udzielali stronie trzeciej pomocy w tworzeniu lub wsparciu
      produktów i usług konkurencyjnych wobec Usług; (d) nie usuwali, ani nie modyfikowali adnotacji
    ani oznaczeń dotyczących praw własności do Usług.</li>
    <li> Ponadto Klient nie może oraz dołoży starań, by jego Administrator/Administratorzy i Użytkownicy
      Końcowi: (a) nie wykorzystywali Usług do działań, w przypadku których awaria Usług mogłaby
      skutkować uszkodzeniem fizycznym, uszkodzeniem ciała, bądź śmiercią; (b) nie korzystali z Usług,
      ani nie umożliwiali korzystania z Usług do działań niezgodnych z prawem, nieuczciwych,
      obraźliwych bądź szkodliwych; (c) nie korzystali z Usług w sposób, który mógłby skutkować
      uszkodzeniem, wyłączeniem, przeciążeniem, pogorszeniem, lub innym zakłóceniem świadczenia Usług,
      w tym poprzez rozsyłanie wirusów lub uszkodzonych plików; ani (d) nie korzystali z Usług w celu
      naruszenia bądź sprzeniewierzenia praw własności intelektualnej lub praw własności innych osób.
    </li>
    <li> Klient przyjmuje do wiadomości, że ponosi odpowiedzialność za przestrzeganie stosownych
      przepisów, ogólnych lub właściwych dla branży, oraz że firma Sharp, Sprzedawca i/lub Zewnętrzni
      Dostawcy Usług nie ponoszą odpowiedzialności w przypadku niewywiązania się przez Klienta z tego
    obowiązku.</li>
    <li> Klient ponosi wyłączną odpowiedzialność za pozyskanie i utrzymywanie odpowiedniego sprzętu i
      usług pomocniczych potrzebnych do celów podłączenia, uzyskiwania dostępu, dostarczania bądź
      innego korzystania z Usług, w tym m.in. komputerów, systemu operacyjnego/systemów operacyjnych
      oraz przeglądarki sieciowej/przeglądarek sieciowych, dostępu do Internetu, urządzeń mobilnych,
      wielofunkcyjnych urządzeń peryferyjnych („MFP”), systemów do prezentacji, a także innych
      urządzeń i akcesoriów elektronicznych (razem: „Sprzęt”). Klient dołoży starań, by Sprzęt był
      zgodny z konfiguracjami i specyfikacjami przedstawionymi w Dokumentacji, o ile istnieją, do
      Usług. Dostęp do Dokumentacji związanej z Określonymi Usługami dot. Oprogramowania można uzyskać
    poprzez Określone Usługi dot. Oprogramowania.</li>
    <li> W przypadku gdy Klient podpisał umowę na subskrypcję ze Sprzedawcą lub Zewnętrznym Dostawcą
      Usług, dotyczącą Usług bądź ich części, Klient zastosuje się do postanowień umowy, w tym
      dotyczących płatności wszelkich stosownych opłat, ponieważ niewywiązanie się z tego zobowiązania
      może skutkować zawieszeniem lub wyłączeniem Konta Klienta lub dostępu do Usług i korzystania z
    Usług, bądź ich części.</li>
    <li> W przypadku otrzymania przez Klienta wezwania do stawiennictwa w sądzie, orzeczenia sądowego,
      lub innego żądania związanego z Usługami, Kontem Klienta lub Danymi Klienta, Klient zareaguje na
      takie żądanie korzystając z dostępu do Danych Klienta. W przypadku gdy Klient nie może uzyskać
      dostępu do żądanych Danych Klienta lub innych żądanych informacji, Klient skontaktuje się z
      firmą Sharp, a Sharp dołoży uzasadnionych z handlowego punktu widzenia starań, by udzielić
      Klientowi pomocy w tym zakresie. W przypadku braku szybkiej reakcji Klienta, Sharp może udzielić
      odpowiedzi na tego rodzaju żądanie pochodzące od strony trzeciej, jednak nie ma takiego
      obowiązku. W przypadku otrzymania przez firmę Sharp, Sprzedawcę i/lub Zewnętrznego Dostawcę
      Usług wezwania do stawiennictwa w sądzie, orzeczenia sądowego, lub innego żądania, w związku z
      Usługami, Kontem Klienta, lub Danymi Klienta, w tym m.in. Kontami Administratora bądź innymi
      danymi w ramach Konta Klienta, Sharp, Sprzedawca, lub Zewnętrzny Dostawca Usług zastosuje się do
      wezwania, orzeczenia sądowego lub żądania zgodnie z obowiązującymi przepisami. Dodatkowe
      informacje na temat potencjalnego koniecznego dostępu i korzystania przez Sharp z Kont Klienta
      podano w polityce prywatności <a tabindex="-1" class="text_underline" [href]="privacyUrl"
      target="_blank"><b>Synappx Privacy Policy</b></a>.</li>
      <li> Klient odpowiada za naruszenie postanowień niniejszego punktu - przez Klienta, w tym przez
        Administratora/Administratorów i Użytkowników Końcowych. Klient przyjmuje do wiadomości, że
        Sharp, Sprzedawca, ani Zewnętrzni Dostawcy Usług nie ponoszą odpowiedzialności za działania
      Użytkownika Końcowego wobec Klienta ani wobec innych stron.</li>
    </ol>
  </div>
  <div class="eula_points">
    <b>C. Funkcja Administratora</b>
    <ol>
      <li> Wszyscy Administratorzy mają obowiązek korzystać z Usług zgodnie z niniejszą Umową, Warunkami
        Dodatkowymi, Dokumentacją, o ile ma zastosowanie, oraz wszelkimi zobowiązaniami, warunkami i
        politykami Klienta dotyczącymi zatrudnienia, a także z przepisami, w tym ustawowymi i
      wykonawczymi, które mają zastosowanie w przypadku dostępu i/lub korzystania z Usług.</li>
      <li> Administrator przyjmuje do wiadomości, że Klient może przydzielać i zmieniać przydział
      dodatkowych Kont Administratora.</li>
      <li> Podczas korzystania z konta Administratora Synappx Admin, Administrator sprawuje kontrolę nad
        Kontem Klienta poprzez zarządzanie Kontem Klienta, w tym licencjami (pojedynczymi lub w
      pakiecie) związanymi z Kontem Klienta.</li>
      <li> Administrator może tworzyć, przyznawać dostęp, monitorować, ograniczać, zawieszać i odbierać
        dostęp do wszystkich Kont Klienta, w tym dodatkowych Kont Administratora, licencji przestrzeni
      roboczej (Workspace) i Licencji Użytkowników Końcowych.</li>
      <li> Administrator może również być Użytkownikiem Końcowym, w takim przypadku wszelkie postanowienia
        niniejszej Umowy i Warunki Dodatkowe dotyczące Użytkownika Końcowego mają zastosowanie również
      do Administratora występującego w charakterze Użytkownika Końcowego.</li>
    </ol>
  </div>
  <div class="eula_points">
    <b>D. Korzystanie przez Użytkownika Końcowego</b>
    <ol>
      <li> Klient dołoży starań, by Użytkownicy Końcowi korzystali z Usług zgodnie z niniejszą Umową,
        Warunkami Dodatkowymi, Dokumentacją, o ile ma zastosowanie, oraz wszelkimi zobowiązaniami,
        warunkami i politykami Klienta dotyczącymi zatrudnienia, a także z przepisami, w tym ustawowymi
      i wykonawczymi, które mają zastosowanie w przypadku dostępu i/lub korzystania z Usług.</li>
      <li> Klient odpowiada za dostęp i korzystanie z Usług przez Użytkowników Końcowych.</li>
      <li> Użytkownik Końcowy nie może oddzielać swoich działań w ramach Usług od Klienta.</li>
      <li> Klient oświadcza, że: (a) Użytkownik Końcowy posiada wszelkie prawa i licencje na dostęp i
        korzystanie z Usług; (b) przechowywanie, transmisja, przetwarzanie informacji związanych z
        Użytkownikiem Końcowym i dostępem Użytkownika Końcowego do Usług nie stanowi naruszenia
        postanowień niniejszej Umowy, Warunków Dodatkowych, stosownej Dokumentacji, praw własności
        intelektualnej, ani praw własności innych tron, ani stosownych przepisów ustawowych i
      wykonawczych.</li>
      <li> Klient przyjmuje do wiadomości, że ponosi wyłączną odpowiedzialność za naturę, jakość i
      prawidłowość działań Użytkownika Końcowego związanych z Usługami.</li>
    </ol>
  </div>
  <div class="eula_points">
    <b>E. Funkcja Sprzedawcy</b>
    <ol>
      <li> Sprzedawca ponosi odpowiedzialność za utworzenie Konta Klienta i dostarczenie licencji na
        Usługi Administratorowi/Administratorom. Po utworzeniu Administratora dla Klienta, Sprzedawca
      nie może tworzyć Kont Administratora.</li>
      <li> Sprzedawcy mogą zarządzać licencjami na Konta Klienta, w tym zakupem i zakończeniem licencji. O
        ile w niniejszej Umowie nie postanowiono inaczej, Sprzedawca nie może zakończyć licencji, która
      została już przekazana Administratorowi.</li>
      <li> Sprzedawcy posiadają dostęp do podstawowych informacji o Kontach Klienta, a także do nazwy,
        adresu, numerów telefonów Klienta, oraz nazw i adresów email wszystkich Administratorów.
        Ponadto, Sprzedawcy posiadają dostęp i mogą przeglądać wszystkie licencje na Usługi do Konta
      Klienta.</li>
      <li> Sprzedawca może zawiesić i/lub cofnąć dostęp Klienta do Konta Klienta.</li>
      <li> W przypadku gdy Sprzedawca nie może, bądź nie ma już uprawnień do obsługi Konta Klienta, firma
        Sharp lub jej spółka zależna może, według własnego uznania, przenieść Konto Klienta do innego
      Sprzedawcy. Sprzedawca nie może samodzielnie przenieść Konta Klienta do innego Sprzedawcy.</li>
      <li>Sprzedawca może korzystać z Usług jako Użytkownik Końcowy na żądanie Klienta.</li>
    </ol>
  </div>
  <div class="eula_points"><b>F. Usługi</b>
  <ol>
    <li> Klienci mogą uzyskiwać dostęp i korzystać z Usług wyłącznie zgodnie z postanowieniami
      niniejszej Umowy, Warunkami Dodatkowymi, Dokumentacją, oraz wszelkimi innymi warunkami
      korzystania lub polityką prywatności mającą zastosowanie do dostępu i/lub korzystania z Usług.
      Niezastosowanie się przez Klienta do niniejszej Umowy, Warunków Dodatkowych, Dokumentacji,
      stosownych przepisów ustawowych i wykonawczych, może skutkować zawieszeniem bądź zamknięciem
    Konta Klienta lub Konta Administratora, według uznania firmy Sharp.</li>
    <li> Usługi lub ich części mogą podlegać umowom na subskrypcję zawieranym ze Sprzedawcami i/lub
      Zewnętrznymi Dostawcami Usług; niewywiązanie się przez Klienta z takich umów, w tym m.in. z
      pokrycia wszelkich stosownych opłat, może skutkować zawieszeniem lub zamknięciem Konta Klienta,
    albo dostępu i korzystania z Usług, bądź ich części.</li>
    <li> Dostęp i korzystanie z Usług są również uzależnione od otrzymania przez firmę Sharp od
      Sprzedawcy wszelkich opłat Klienta za dostęp i korzystanie z Usług; w przypadku gdy firma Sharp,
      lub jej spółka zależna, nie otrzyma od Sprzedawcy opłat, którym podlega Konto Klienta, a braki
      te nie zostaną usunięte w terminie trzydziestu (30) dni od pisemnego powiadomienia, Sharp, albo
      spółka zależna może, według własnego uznania, zawiesić lub zamknąć Konto Klienta do czasu
    otrzymania należnej opłaty przez Sharp lub spółkę zależną.</li>
    <li> Sharp dołoży uzasadnionych z handlowego punktu widzenia starań, by wszelkie urządzenia
      wykorzystywane do przechowywania i przetwarzania Danych Klienta były zgodne z uzasadnionymi z
      handlowego punktu widzenia standardami bezpieczeństwa. Korzystając z Usług, Klient wyraża zgodę
    na transfer, przetwarzanie i przechowywanie Danych Klienta przez firmę Sharp.</li>
    <li> Klient przyjmuje do wiadomości, że Sharp i/lub Zewnętrzni Dostawcy Usług mogą co jakiś czas
    aktualizować Usługi, po powiadomieniu lub bez powiadomienia Klienta.</li>
    <li> Niezależnie od innych postanowień Umowy, w przypadku stwierdzenia, że Dane Klienta stanowią
      bądź mogą stanowić naruszenie Umowy, lub w jakikolwiek sposób szkodzić, stanowić nadmierne
      obciążenie, zagrażać lub powodować uszkodzenie Usług, Dane Klienta mogą zostać usunięte, w
      całości bądź w części, według uznania Sharp, po lub bez uprzedniego powiadomienia Klienta, zaś
      Sharp nie ponosi za to odpowiedzialności. Klient ponosi odpowiedzialność za stworzenie kopii
    zapasowych Danych Klienta na wypadek usunięcia.</li>
    <li> Dodatkowe warunki dot. prywatności, przetwarzania i przechowywania Danych Klienta, a także
      dostępu do Kont Klienta przedstawiono w polityce prywatności <a tabindex="-1"
      class="text_underline" [href]="privacyUrl" target="_blank"><b>Synappx Privacy Policy</b></a>
    i stosownej Dokumentacji dot. Usług.</li>
  </ol>
</div>
<div class="eula_points"><b>G. Wsparcie</b>
<ol>
  <li> Klient odpowiada za utrzymywanie kontaktu ze Sprzedawcą we wszystkich kwestiach wsparcia dot.
    Usług, których nie można rozwiązać w oparciu o Dokumentację dot. Określonych Usług dot.
  Oprogramowania.</li>
  <li> O ile firma Sharp lub oddział sprzedaży Sharp nie jest Sprzedawcą Twojego Konta Klienta, Sharp
    nie ponosi wobec Klienta odpowiedzialności za kwestie związane z powyższymi Usługami, ani za ich
    wsparcie, w zakresie większym niż opisany w Dokumentacji Określonych Usług dot. Oprogramowania.
  </li>
</ol>
</div>
<div class="eula_points"><b>H. Własność Intelektualna</b>
<ol>
  <li> Niniejsza Umowa nie daje firmie Sharp, Sprzedawcy, ani Zewnętrznym Dostawcom Usług praw do
    Danych Klienta, ani praw własności intelektualnej do Konta Klienta, ani Konta Administratora, za
    wyjątkiem ograniczonych praw wyraźnie przedstawionych w Umowie, Warunkach Dodatkowych, bądź
  koniecznych w celu świadczenia Usług i umożliwienia Klientowi korzystania z Usług.</li>
  <li> O ile Umowa lub Warunki Dodatkowe wyraźnie nie stanowią inaczej, Klientowi,
    Administratorowi/Administratorom, ani Użytkownikom Końcowym nie przyznaje się: (a) praw
    własności intelektualnej do Usług ani ich części; (b) praw własności intelektualnej do innych
    Kont Klienta; ani (c) prawa do korzystania z logo, znaków towarowych, oznaczeń usług, nazw
    domen, lub brandingu Sharp, Sprzedawcy, Zewnętrznych Dostawców Usług, do Usług, ani żadnej
  części składowej Usług.</li>
  <li> W zakresie, w jakim Klient, Administrator/Administratorzy, lub Użytkownik Końcowy wystąpił do
    Sharp z prośbą o określone działania w tym m.in. transmisję, hosting lub udostępnienie plików,
    korzystanie lub udostępnienie cech produktu lub ustawień, Klient zezwala firmie Sharp, lub
    Sprzedawcy, na przeprowadzenie wszelkich koniecznych działań w celu świadczenia Usług i
    dostarczenia funkcjonalności dostępnych poprzez Usługi, także tak, jak opisano w Dokumentacji.
    Zezwolenie obejmuje wszelkie usługi Zewnętrznych Dostawców Usług, z których Sharp korzysta w
  celu świadczenia Usług.</li>
</ol>
</div>

<div class="eula_point">
  <div><b>I. Wyłączenia odpowiedzialności</b></div>
  <div class="eula_point_left">SHARP DOŁOŻY WSZELKICH UZASADNIONYCH Z HANDLOWEGO PUNKTU WIDZENIA STARAŃ,
    BY MOŻLIWIĆ KLIENTOWI DOSTĘP I KORZYSTANIE Z USŁUG, ZGODNIE Z NINIEJSZĄ UMOWĄ, WARUNKAMI DODATKOWYMI
    I WSZELKĄ STOSOWNĄ DOKUMENTACJĄ. NIEZALEŻNIE OD INNYCH POSTANOWIEŃ UMOWY, USŁUGI SĄ DOSTARCZANE „W
    STANIE, W JAKIM SĄ”. W NAJSZERSZYM ZAKRESIE DOPUSZCZALNYM PRZEZ PRAWO, O ILE W NINIEJSZEJ UMOWIE
    WYRAŹNIE NIE STWIERDZONO INACZEJ, SHARP WYŁĄCZA WSZELKIE GWARANCJE, W IMIENIU WŁASNYM, SPRZEDAWCY I
    ZEWNĘTRZNYCH DOSTAWCÓW USŁUG, WYRAŹNE I DOROZUMIANE, W TYM GWARANCJE, ŻE USŁUGA BĘDZIE ŚWIADCZONA W
    SPOSÓB NIEPRZERWANY, BEZ BŁĘDÓW, ŻE TREŚCI BĘDĄ BEZPIECZNE I NIE ZOSTANĄ UTRACONE ANI USZKODZONE, ŻE
    WADY ZOSTANĄ NAPRAWIONE, ORAZ GWARANCJE POKUPNOŚCI, PRZYDATNOŚCI DO OKREŚLONEGO CELU I GWARANCJE
    NIENARUSZANIA PRAW STRON TRZECICH. SHARP NIE ODPOWIADA ZA TREŚCI, W TYM DANE KLIENTA I DANE Z KONTA
    KLIENTA ZNAJDUJĄCE SIĘ NA KONCIE KLIENTA BĄDŹ POCHODZĄCE Z KONTA KLIENTA, ZAŚ KLIENT PONOSI WYŁĄCZNĄ
  ODPOWIEDZIALNOŚĆ ZA WSZELKIE DANE KLIENTA, A TAKŻE ZA DOSTĘP I KORZYSTANIE Z USŁUG.</div>
</div>

<div class="eula_points"><b>J. Okres obowiązywania i wypowiedzenie</b>
<ol>
  <li> Niniejsza Umowa obowiązuje do momentu wygaśnięcia subskrypcji Klienta, lub dostępu do Usług,
    lub do momentu rozwiązania zgodnie z postanowieniami Umowy. Klient przyjmuje do wiadomości, że
    niektóre z Określonych Usług dot. Oprogramowania mogą wygasnąć wcześniej, zgodnie z
  postanowieniami stosownych Warunków Dodatkowych.</li>
  <li> Sprzedawca może zamknąć Konto Klienta w przypadku gdy klient nie wniesie opłaty za subskrypcję
  należnej Sprzedawcy za dostęp i korzystanie z Usług przez Klienta.</li>
  <li> Sharp może wypowiedzieć Umowę oraz dostęp i korzystanie z Usług, w przypadku gdy nie otrzyma od
    Sprzedawcy opłaty za dostęp i korzystanie z Usług przez Klienta, jeżeli stwierdzone braki nie
    zostaną usunięte w terminie trzydziestu (30) dni od pisemnego powiadomienia; zawieszenie lub
  wypowiedzenie może pozostać w mocy do chwili otrzymania przez Sharp należnych opłat.</li>
  <li> Niniejsza Umowa, dostęp i korzystanie z Usług podlegają automatycznemu odnowieniu, o ile Klient
  nie powiadomi Sprzedawcy o zamiarze rezygnacji z Usług.</li>
  <li> Ponadto, firma Sharp lub jej spółka zależna może wypowiedzieć Umowę w przypadku naruszenia
    przez Klienta istotnego postanowienia Umowy, gdy braki nie zostaną usunięte w terminie
    trzydziestu (30) dni od otrzymania powiadomienia na piśmie; powiadomienie na piśmie można
  przesłać pocztą elektroniczną lub drogą elektroniczną w inny sposób.</li>
  <li> W przypadku rozwiązania Umowy prawa przysługujące Klientowi, Administratorowi/Administratorom i
    Użytkownikom Końcowym natychmiast ustają, za wyjątkiem tego, że Konto Klienta i Dane Klienta w
    ramach Konta Klienta pozostaną dostępne przez piętnaście (15) dni od daty zakończenia
    subskrypcji. Po wygaśnięciu lub rozwiązaniu Umowy, z jakichkolwiek przyczyn, za wyjątkiem
    sytuacji wyraźnie wskazanych w tym Punkcie, Klient zgadza się na natychmiastowe zaniechanie
    dostępu i korzystania z Usług. Klient przyjmuje do wiadomości i zgadza się, że Sharp i/lub
    Zewnętrzni Dostawcy Usług nie mają obowiązku przechowywać Danych Klienta po upływie
    trzydziestodniowego (30 dni) okresu, o którym mowa w Umowie, oraz że po upływie
    trzydziestodniowego okresu wszystkie Dane Klienta mogą zostać usunięte bez możliwości
  odzyskania.</li>
  <li> Niezależnie od rozwiązania bądź wygaśnięcia Umowy, Klient w dalszym ciągu ponosi
    odpowiedzialność za opłaty, które mogą być należne Sprzedawcy, na mocy umowy ze Sprzedawcą, lub
    na innej podstawie, za korzystanie i dostęp do Usług przed datą rozwiązania lub wygaśnięcia
  Umowy.</li>
  <li> Powiadomienia wysyłane do Klienta, zgodnie z niniejszym punktem mogą być przesyłane mailem, lub
  inną drogą elektroniczną i mogą być kierowane do Administratora/Administratorów.</li>
  <li> Poniższe punkty Umowy pozostają w mocy po jej wygaśnięciu bądź rozwiązaniu, niezależnie od
  przyczyn: Punkty F(6), H, I, J(6) do J(9), K, L, M, Q oraz S.</li>
  <li>Punkty 1 do 9 niniejszego artykułu J (Okres obowiązywania i wypowiedzenie) nie mają zastosowania
    do Synappx Manage.
    Synappx Manage może przerwać bezpłatne użytkowanie Klienta w dowolnym momencie i z dowolnego
    powodu według wyłącznego
  uznania firmy Sharp, bez ponoszenia odpowiedzialności wobec Klienta.</li>
</ol>
</div>
<div class="eula_point">
  <div><b>K. Zwolnienie z odpowiedzialności</b></div>
  <div class="eula_point_left">Klient zobowiązuje się do zwolnienia z odpowiedzialności, obrony i
    zabezpieczenia firmy Sharp, jej Sprzedawców, Zewnętrznych Dostawców Usług i innych powiązanych
    podmiotów, m.in. spółek-matek, spółek zależnych, dyrektorów, kierowników, pracowników, pośredników i
    wykonawców (razem: „Strony Sharp”) od wszelkiej odpowiedzialności, odszkodowań i kosztów (w tym
    kosztów ugody i uzasadnionych kosztów obsługi prawnej) powstałych w związku z roszczeniami strony
    trzeciej dotyczącymi: (a) korzystania z Usług przez Klienta; (b) wszelkich Danych Klienta; (c)
    naruszenia postanowień niniejszej Umowy przez Klienta, Administratora/Administratorów i/lub
    Użytkowników Końcowych; oraz (d) naruszenia bądź domniemanego naruszenia stosownych przepisów
    ustawowych bądź wykonawczych mających zastosowanie do Klienta, Administratora i/lub Użytkownika
    Końcowego w związku z Usługami. Zgodnie z niniejszym punktem Sharp podejmie uzasadnione z handlowego
  punktu widzenia kroki, by powiadomić Klienta o tego rodzaju roszczeniach lub żądaniach.</div>
</div>

<div class="eula_point">
  <div><b>L. Ograniczenie odpowiedzialności</b></div>
  <div class="eula_point_left">W NAJSZERSZYM ZAKRESIE DOPUSZCZALNYM PRZEZ PRAWO, W ŻADNYCH
    OKOLICZNOŚCIACH, STRONY SHARP NIE PONOSZĄ ODPOWIEDZIALNOŚCI WOBEC KLIENTA,
    ADMINISTRATORA/ADMINISTRATORÓW, UŻYTKOWNIKÓW KOŃCOWYCH, ANI INNYCH STRON TRZECICH, ZA JAKIEKOLWIEK
    SZKODY BEZPOŚREDNIE, SZCZEGÓLNE, UBOCZNE, POŚREDNIE LUB NASTĘPCZE, W TYM MIĘDZY INNYMI UTRATĘ
    ZYSKÓW, DANYCH, KORZYSTANIA LUB TREŚCI, LUB INNĄ UTRATĘ POWSTAŁĄ W ZWIĄZKU Z UMOWĄ LUB WYNIKAJĄCĄ Z
    UMOWY, WARUNKTÓW DODATKOWYCH, USŁUG, KONTA KLIENTA LUB DANYCH KLIENTA. NINIEJSZY PUNKT MA
    ZASTOSOWANIE NIEZALEŻNIE OD TEGO, CZY ODPOWIEDZIALNOŚĆ WIĄŻE SIĘ Z KONTRAKTEM, CZYNEM ZAKAZANYM,
    ZANIEDBANIEM, NARUSZENIEM GWARANCJI, ODPOWIEDZIALNOŚCIĄ ŚCISŁĄ BĄDŹ INNĄ, I BEZ WZGLĘDU NA TO, CZY
    STRONY SHARP ZOSTAŁY POINFORMOWANE O MOŻLIWOŚCI TAKICH SZKÓD. CAŁKOWITA ODPOWIEDZIALNOŚĆ STRON SHARP
    WOBEC KLIENTA BĄDŹ INNEJ STRONY TRZECIEJ W ŻADNYM WYPADKU NIE MOŻE PRZEKROCZYĆ KWOTY RÓWNEJ OPŁACIE
    ZA TRZY MIESIĄCE ŚWIADCZENIA USŁUGI. NINIEJSZYM ZWALNIA SIĘ STRONY SHARP Z WSZELKICH ZOBOWIĄZAŃ,
    ODPOWIEDZIALNOŚCI I ROSZCZEŃ PRZEKRACZAJĄCYCH ZAKRES TEGO OGRANICZENIA. NINIEJSZE OGRANICZENIE
    ODPOWIEDZIALNOŚCI OBOWIĄZUJE PO WYGAŚNIĘCIU LUB ROZWIĄZANIU UMOWY, NIEZALEŻNIE OD PRZYCZYN, I MA
    ZASTOSOWANIE NAWET JEŚLI KTÓRYŚ Z OGRANICZONYCH ŚRODKÓW ZARADCZYCH, O KTÓRYCH MOWA W TYM PUNKCIE NIE
  SPEŁNIŁ SWEGO ZASADNICZEGO CELU.</div>
</div>

<div class="eula_point list_custom">
  <div><b>M. Prawo właściwe/Odstąpienie od rozprawy przed ławą przysięgłych</b></div>
  <div class="eula_point_left">Jeśli Klient korzysta z Usług wyłącznie w celach prywatnych, a nie
    biznesowych, niniejsza Umowa podlega prawu
  jurysdykcji, w której Klient nabył lub uzyskał licencję na korzystanie z Usług.</div>
  <div class="eula_point_left">Jeśli Użytkownik nie jest takim konsumentem, niniejsza Umowa będzie
    podlegać i będzie interpretowana zgodnie z prawem
  materialnym obowiązującym w:</div>
  <ol>
    <li>stanie Nowy Jork, jeśli licencja na korzystanie z Usług została zakupiona lub uzyskana, gdy
      Klient przebywa w Stanach
    Zjednoczonych, Kanadzie lub Meksyku;</li>
    <li>Anglii i Walii, jeśli licencja na korzystanie z Usług została zakupiona lub uzyskana, gdy Klient
      przebywa w Wielkiej
    Brytanii lub w jakimkolwiek kraju EOG;</li>
    <li>kraju Unii Europejskiej, w którym znajduje się Klient, jeżeli licencja na korzystanie z Usług
      została zakupiona lub
    uzyskana przez Klienta w tym kraju Unii Europejskiej;</li>
    <li>Japonii, jeśli licencja na korzystanie z Usług została zakupiona lub uzyskana, gdy Klient
      znajduje się w jakiejkolwiek
    jurysdykcji nieopisanej powyżej;</li>
  </ol>
  <div class="eula_point_left">Odpowiednie sądy właściwe:</div>
  <ol>
    <li>
      Hrabstwa Nowy Jork, Nowy Jork, gdy zastosowanie ma prawo stanu Nowy Jork;
    </li>
    <li>
      Anglii i Walii, gdy zastosowanie ma prawo Anglii i Walii;
    </li>
    <li>
      państwa członkowskiego Unii Europejskiej Klienta, gdy zastosowanie ma prawo tego państwa
      członkowskiego Unii
      Europejskiej;
    </li>
    <li>
      Sąd Okręgowy w Osace w Japonii, gdy zastosowanie ma prawo japońskie
    </li>
    miały będą niewyłączną jurysdykcję we wszystkich sporach związanych z niniejszą Umową.
  </ol>
  <div class="eula_point_left">Wszelkie powództwa przeciwko Stronom Sharp powstałe w związku z niniejszą Umową należy wnieść w ciągu jednego (1) roku
    po powstaniu roszczenia, po tym czasie ulegną one przedawnieniu. Klient i Sharp niniejszym odstępują od prawa do
  rozprawy przed ławą przysięgłych w przypadku sporów powstałych w związku z Umową lub Usługami.</div>
</div>

<div class="eula_point">
  <div><b>N. Znaki towarowe</b></div>
  <div class="eula_point_left">Znaki towarowe i oznaczenia usług „SHARP”, „Synappx”, „Synappx Meeting”,
    „Synappx Go” i powiązane z nimi nazwy produktów, nazwy usług oraz logo stosowane, przytaczane i/lub
    przywoływane na bądź podczas Usług są znakami towarowymi, zarejestrowanymi znakami towarowymi i
    oznaczeniami usług należącymi do Sharp i/lub podmiotów powiązanych. Wszelkie inne nazwy produktów,
    usług, logo i/lub nazwy firm występujące na lub w Usługach należą do ich właścicieli i mogą podlegać
    ochronie jako znaki towarowe, zarejestrowane znaki towarowe, oznaczenia usług i/lub nazwy branżowe.
  </div>
</div>

<div class="eula_point">
  <div><b>O. Siła wyższa</b></div>
  <div class="eula_point_left">Strony Sharp, Zewnętrzni Dostawcy Usług, ani Klient nie ponoszą
    odpowiedzialności za niewłaściwe wykonanie umowy w zakresie spowodowanym przez warunki pozostające
    poza kontrolą strony, w tym m.in. klęskę żywiołową, wojnę, terroryzm, zamieszki, działania rządu,
    warunki pracy, lub zakłócenia albo usterki w działaniu sieci elektrycznej, telekomunikacyjnej lub
    Internetu. Sharp i Klient zgadzają się dołożyć uzasadnionych starań w celu złagodzenia skutków
  działania siły wyższej.</div>
</div>

<div class="eula_point">
  <div><b>P. Eksport</b></div>
  <div class="eula_point_left">Klient przyjmuje do wiadomości, że korzystanie z Usług i rezultaty dostępu
    i korzystania z Usług (w tym dane techniczne) podlegają miejscowym przepisom eksportowym (do kraju
    korzystania z Usług), Klient zgadza się przestrzegać tych przepisów eksportowych (w tym dotyczących
    „domniemanego wywozu” i „domniemanego powrotnego wywozu”). Klient przyjmuje do wiadomości, że dane,
    informacje, oprogramowanie, ani materiały wynikłe z Usług (lub ich bezpośredniego produktu) nie mogą
    być eksportowane, bezpośrednio ani pośrednio, z naruszeniem tych przepisów, ani wykorzystywane do
    celów zakazanych tymi przepisami, w tym, bez ograniczeń, do celów rozprzestrzeniania (proliferacji)
    broni nuklearnej, chemicznej lub biologicznej, ani do tworzenia technologii pocisków rakietowych.
  </div>
</div>

<div class="eula_point">
  <div><b>Q. Dane statystyczne</b></div>
  <div class="eula_point_left">Niezależnie od postanowień Umowy i innych, Sharp może monitorować
    korzystanie z Usług przez Klienta i wykorzystywać Dane Klienta w formie zbiorczej, zanonimizowanej,
    tworzyć zbiory informacji statystycznych, informacji o użytkowaniu i działaniu związanych ze
    świadczeniem i działaniem Usług i upubliczniać takie informacje („Dane Zbiorcze”), pod warunkiem, że
    Dane Zbiorcze nie umożliwiają identyfikacji Klienta i nie ujawniają Danych Klienta. Sharp zachowuje
  wszelkie prawa własności intelektualnej do Danych Zbiorczych.</div>
</div>

<div class="eula_points"><b>R. Zmiana warunków</b>
<ol>
  <li> Sharp może co jakiś czas zmieniać i modyfikować warunki niniejszej Umowy, według własnego
    uznania. W przypadku zmiany lub modyfikacji warunków, Administrator/Administratorzy muszą
    zaakceptować zmienione bądź zmodyfikowane warunki podczas pierwszego logowania po wejściu w
    życie zmian lub modyfikacji. Aktualna wersja Umowy zostanie opublikowana na stronie wsparcia <a
    tabindex="-1" class="text_underline" [href]="termsUseUrl" target="_blank">Synappx Support
  Site</a> Za zapoznawanie się co jakiś czas ze stroną odpowiada Klient. Sharp dołoży
  uzasadnionych starań, by powiadomić o zmianie na trzydzieści (30) dni przed datą jej wejścia w
  życie, jednak w przypadku niektórych zmian okres ten będzie krótszy niż trzydzieści (30) dni.
</li>
<li> Jeśli Klient w dalszym ciągu korzysta z Usług po dacie wejścia w życie zmienionej lub
  zmodyfikowanej Umowy, przyjmuje do wiadomości, że on sam, jego Administrator/Administratorzy i
  Użytkownicy Końcowi są od tej pory związani nowymi warunkami. Jeśli Klient nie akceptuje
zmienionych warunków Umowy może zaprzestać korzystania i dostępu do Usług.</li>
</ol>
</div>
<div class="eula_points"><b>S. Warunki dodatkowe</b>
<ol>
  <li> Klient przyjmuje do wiadomości, że nie jest związany z Sharp w ramach spółki, spółki typu joint
  venture, ani umowy o przedstawicielstwo.</li>
  <li> O ile Klient nie udzieli Sharp konkretnych pisemnych instrukcji o przeciwnej treści, Sharp może
    umieścić nazwę klienta na liście klientów w materiałach marketingowych Sharp, w tym na stronach
  internetowych.</li>
  <li> O ile w Umowie nie określono inaczej, ogólne powiadomienia kierowane przez Sharp do Klienta lub
    Użytkowników Końcowych, a dotyczące niniejszej Umowy lub Usług będą publikowane na stronie
    wsparcia <a tabindex="-1" class="text_underline" [href]="supportType" target="_blank">Synappx
  Support Site</a>. W związku z tym Klient i Użytkownicy Końcowi muszą regularnie odwiedzać
  stronę <a tabindex="-1" class="text_underline" [href]="supportType" target="_blank">Synappx
Support Site</a>, aby zapoznać się z powiadomieniami. Konkretne powiadomienia dotyczące Usług
będą trafiać na udostępniony adres e-mail Administratora. Wszelkie powiadomienia, w tym związane
z kwestiami prawnymi, pytania i uwagi dotyczące Umowy należy kierować do: <br>
<span>Synappx Product Manager</span>
<div>Sharp Corporation </div>
<div>492 Minosho-cho, Yamato-Koriyama City, </div>
<div>Nara 639-1186, Japan</div>
</li>
<li> Klient nie może dokonywać cesji ani przenosić żadnej części Umowy bez pisemnej zgody Sharp.
  Sharp może dokonywać cesji zobowiązań wynikłych z Umowy po powiadomieniu Klienta, pocztą
  elektroniczną, pocztą, lub w powiadomieniu przesłanym poprzez Usługi. Niezależnie od odmiennych
  postanowień Umowy, Sharp może przenieść zobowiązania wynikłe z Umowy na podmiot powiązany lub w
  związku z fuzją, przejęciem, reorganizacją, lub sprzedażą wszystkich lub znacznej większości
aktywów, bez powiadomienia Klienta.</li>
<li> Odstąpienie przez Sharp od dochodzenia jednego z praw z tytułu naruszenia Umowy nie oznacza
odstąpienia od dochodzenia innych praw.</li>
<li> W przypadku gdy którekolwiek z postanowień Umowy (lub jego część) okaże się niewykonalne lub
  niezgodne z prawem, zostanie zmodyfikowane w najmniejszym możliwym zakresie, który zapewni jego
wykonalność, zaś pozostałe części Umowy pozostaną wiążące.</li>
<li> Niniejsza Umowa i Warunki Dodatkowe stanowią całość porozumienia zawartego pomiędzy Klientem a
  firmą Sharp w zakresie Usług, zastępując wszelkie porozumienia lub umowy, w tym zamówienia,
  zawarte wcześniej lub w tym samym czasie w formie pisemnej lub ustnej i dotyczące kwestii
wskazanych w Umowie.</li>
</ol>
</div>
</div>
</div>
<div mat-dialog-actions>
  <button mat-button class="primary_btn" (click)="agreeClick()" id="eula-id-agree-button"
  name="eula-name-agree-button">{{"Agree" |translate}}</button>
  <button #eulaCancelButton mat-button (click)="onCancel()" class="secondary_btn" id="eula-id-cancel-button"
  name="eula-name-cancel-button">{{"Decline" |translate}}</button>
</div>
</div>
